<template>
  <div class="list">
    <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
      :loading-text="$t('Hint.loading')" immediate-check>
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap app_card">
          <div class="item_wrap_head">
            <div class="head_left">
              <div class="head_left_title">{{ item.side == 'buy' ? $t('买入余额') : $t('卖出余额') }}</div>
              <div class="head_left_desc">{{ item.order_no }}</div>
            </div>
            <div class="head_status">{{ getStatus(item.status) }}</div>
          </div>
          <div class="item_wrap_moneys">
            <div class="money_item">
              <div class="money_title">{{ $t('可交易') }}</div>
              <div class="money_val">{{ $money(item.available_amount || '0.00') }}</div>
            </div>
            <div class="money_item">
              <div class="money_title">{{ $t('挂单总额') }}</div>
              <div class="money_val">{{ $money(item.amount || '0.00') }}</div>
            </div>
          </div>
          <div class="item_wrap_btn" v-if="item.userid == userInfo.id && item.status == 'open'"
            @click="cancelOrder(item)">{{ $t('取消挂单') }}</div>
        </div>
      </template>
      <div class="list_not" v-else>
        <img :src="require('@/assets/Img/null/null.png')" alt="">
        <span>{{ $t('无我的订单') }}</span>
      </div>
    </List>
  </div>
</template>
<script>
import { List, Dialog, Toast } from "vant";
import { post } from "@/utils/newRequest";
import { C2C_ORDER_CANCEL } from "@/api"
import { mapGetters } from "vuex";
export default {
  components: {
    List,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
      loadingRequest: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    getStatus(_status) {
      switch (_status) {
        case 'open':
          return this.$t('已启用')
          break;
        case 'locked':
          return this.$t('锁定')
          break;
        case 'finished':
          return this.$t('完成')
          break;
        case 'cancelled':
          return this.$t('停用')
          break;
        case 'expired':
          return this.$t('过期')
          break;
        default:
          break;
      }
    },
    async getList(lower = false) {
      if (this.loadingRequest) return;
      this.loadingRequest = true;
      if (!lower) {
        this.page++;
      }
      this.loading = true;
      try {
        const { lists, hasMorePages, total: _total } = await post("/c2c/my/orders", {
          pagesize: 20,
          page: this.page,
        });
        const realList = lists;
        this.hasMore = hasMorePages;
        if (lower) {
          this.list = [...realList]
        } else {
          this.list = [...this.list, ...realList];
        }
        this.loading = false;
        this.loadingRequest = false;
      } catch (error) {
        if (!lower) this.page--;
        this.loading = false;
        this.loadingRequest = false;
      }
    },
    cancelOrder(_item) {
      Dialog({
        title: this.$t('取消挂单'),
        message: this.$t('确认取消该C2C挂单吗'),
        showCancelButton: true,
        cancelButtonText: this.$t('My.Button.One'),
        confirmButtonText: this.$t('My.Button.Two')
      }).then(async () => {
        Toast.loading();
        try {
          const res = await C2C_ORDER_CANCEL({
            id: _item.id
          });
          Toast.clear();
          Toast(res.msg);
          setTimeout(() => {
            this.$store.dispatch('getuserInfo')
            this.page = 0;
            this.getList(true);
          }, 500)
        } catch (error) {
          Toast.clear()
          error.msg && Toast(error.msg);
        }
      }).catch(() => { });
    }
  }
}
</script>
<style lang="less" scoped>
.list {
  :deep(.van-list) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .item_wrap {
    padding: 12px;
    border: 1px solid rgba(15, 23, 42, .06);
    border-radius: 14px;
    background: #fff;

    .item_wrap_head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;

      .head_left {

        .head_left_title {
          line-height: 1;
          color: #111827;
          font-size: 15px;
          font-weight: 900;
        }

        .head_left_desc {
          margin-top: 3px;
          color: #7a8597;
          font-size: 12px;
          font-weight: 800;
        }
      }

      .head_status {
        background: #2f82ff1a;
        color: #3f83ed;
        flex-shrink: 0;
        padding: 4px 8px;
        border-radius: 999px;
        font-size: 12px;
        font-style: normal;
        font-weight: 900;
      }
    }

    .item_wrap_moneys {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
      gap: 8px;
      margin-top: 10px;

      .money_item {
        padding: 9px 10px;
        border-radius: 12px;
        background: #f7f9fc;

        .money_title {
          color: #7a8597;
          font-size: 11px;
          font-weight: 800;
        }

        .money_val {
          margin-top: 4px;
          overflow: hidden;
          color: #111827;
          font-size: 12px;
          font-weight: 900;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .item_wrap_btn {
      height: 32px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #e84f62;
      background: #fff;
      border-radius: 999px;
      border: 1px solid #e84f62;
    }
  }

  .list_not {
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 160px;
      height: 160px;
      display: block;
    }

    span {
      padding: 16px 0;
      color: #0f172a;
      font-size: 14px;
    }
  }
}
</style>